import React from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import Link and useLocation hook
import '../styles/MainMenu.css';
import Button from './Button';


function MainMenu() {
  const location = useLocation(); // Get the current route

  // Function to determine the correct style based on the current routeç
  const getButtonStyle = (link) => {
    if (link === "/projects" && location.pathname.startsWith("/projects")) {
      // Highlight the Projects button for any path under /projects
      return 'outline-blue';
    }
    return link === location.pathname ? 'outline-blue' : 'outline-custom';
  };

  // Function to add a symbol to the active page button
  const getText = (link, title) => {
    if (link === "/projects" && location.pathname.startsWith("/projects")) {
      // Add the symbol for Projects button when on any path under /projects
      return `>${title}`;
    }
    return link === location.pathname ? `> ${title}` : title;
  };

  return (
    <header className="main-menu">
      <div className="header-buttons">
      <Link to="/" className={`btn ${getButtonStyle("/")}`} title={getText("/", "home")}>
          {getText("/", "home")}
        </Link>
        <Link to="/projects" className={`btn ${getButtonStyle("/projects")}`} title={getText("/projects", "projects")}>
          {getText("/projects", "projects")}
        </Link>
        <Link to="/contact" className={`btn ${getButtonStyle("/contact")}`} title={getText("/contact", "contact")}>
          {getText("/contact", "contact")}
        </Link>
        {/* <Link to="/about" className={`btn ${getButtonStyle("/about")}`} title={getText("/about", "about")}>
          {getText("/about", "about")}
        </Link> */}
      </div>
      <hr className="header-divider" />
    </header>
  );
}

export default MainMenu;
